module.exports = __webpack_public_path__ + "img/president.fa245a7e.png";